<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditPaIndexModel" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="分组" prop="PaIndexModel.code" v-if="formData.PaIndexModel.code!=='pa_salary'&&formData.PaIndexModel.code!=='pa_work'&&formData.PaIndexModel.gcode!=='pa_work'">
            <el-select class="input-item" v-model="formData.PaIndexModel.code"
                       :clearable="true" filterable placeholder="分组" :loading="EditPaIndexModel.code.impl.loading"
                       @visible-change="EditPaIndexModel.code.impl.onVisibleChange">
              <el-option v-for="item in EditPaIndexModel.code.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="PaIndexModel.name">
            <el-input class="input-item" v-model="formData.PaIndexModel.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="指标定义" prop="PaIndexModel.pa_work.indexDefinition">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexDefinition"
                      type="textarea" autosize :clearable="true" placeholder="指标定义"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="目标值" prop="PaIndexModel.pa_work.indexTargetValue">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexTargetValue"
                      type="textarea" autosize :clearable="true" placeholder="目标值"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="权重" prop="PaIndexModel.pa_work.indexWeightValue">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.indexWeightValue"
                             :clearable="true" :precision="2" :step="0.01" :max="1"
                             placeholder="权重"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaIndexModel.gcode==='pa_work'&&formData.PaIndexModel.code==='work_lv_a_rate'">
          <el-form-item label="满分线(%)" prop="PaIndexModel.pa_work.fullScoreLine">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.fullScoreLine"
                             :clearable="true" :max="100"
                             placeholder="满分线(%)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaIndexModel.gcode==='pa_work'&&formData.PaIndexModel.code==='work_lv_a_rate'">
          <el-form-item label="扣分系数" prop="PaIndexModel.pa_work.indexWeightValue">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.deductionFactor"
                             :clearable="true" :max="100"
                             placeholder="扣分系数"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="计分规则" prop="PaIndexModel.pa_work.indexScoreRule">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexScoreRule"
                      type="textarea" autosize :clearable="true" placeholder="计分规则"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.code!=='job_salary'">
          <el-form-item label="校验规则" prop="PaIndexModel.verifyRule">
            <el-select class="input-item" v-model="formData.PaIndexModel.verifyRule"
                       :clearable="true" filterable placeholder="校验规则" :loading="EditPaIndexModel.verifyRule.impl.loading"
                       @visible-change="EditPaIndexModel.verifyRule.impl.onVisibleChange">
              <el-option v-for="item in EditPaIndexModel.verifyRule.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="PaIndexModel.sort">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaIndexModel.detail" v-show="formData.PaIndexModel.gcode!=='pa_work'">
            <el-input class="input-item" v-model="formData.PaIndexModel.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaIndexModel.remark">
            <el-input class="input-item" v-model="formData.PaIndexModel.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-collapse :span="24" v-model="activeNames">
            <el-collapse-item title="高级配置" name="advanced">
              <el-col :span="24">
                <el-form-item label="启用条件" prop="PaIndexModel.enableCondition">
                  <el-input class="input-item" v-model="formData.PaIndexModel.enableCondition"
                    :clearable="true" placeholder="启用条件"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="输入变量" prop="PaIndexModel.inputVariable">
                  <el-input class="input-item" v-model="formData.PaIndexModel.inputVariable"
                    :clearable="true" placeholder="输入变量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="参数变量" prop="PaIndexModel.paramVariable">
                  <el-input class="input-item" v-model="formData.PaIndexModel.paramVariable"
                    :clearable="true" placeholder="参数变量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="指标值" prop="PaIndexModel.indexValue">
                  <el-input class="input-item" v-model="formData.PaIndexModel.indexValue"
                    :clearable="true" placeholder="本指标值"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="计算公式" prop="PaIndexModel.evalFormula">
                  <el-input class="input-item" v-model="formData.PaIndexModel.evalFormula"
                    :clearable="true" placeholder="计算公式"
                  />
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPaIndexModel:EditPaIndexModel:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexModelController, DictionaryController } from '@/api';

export default {
  name: 'EditPaIndexModel',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      activeNames: [],
      formData: {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false,
          pa_work: {
            indexDefinition: '',
            indexTargetValue: '',
            indexWeightValue: 0,
            fullScoreLine: 0,
            deductionFactor: 0,
            indexScoreRule: ''
          }
        }
      },
      rules: {
        'PaIndexModel.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'PaIndexModel.type': [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        'PaIndexModel.code': [
          {required: true, message: '请选择分组', trigger: 'blur'}
        ],
        'PaIndexModel.verifyRule': [
          {required: true, message: '请选择校验规则', trigger: 'blur'}
        ]
      },
      EditPaIndexModel: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        code: {
          impl: new DropdownWidget(this.loadCodeDropdownList)
        },
        verifyRule: {
          impl: new DropdownWidget(this.loadVerifyRuleDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onSubmit (code) {
      this.$emit('submit', code);
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 编码下拉数据获取函数
     */
    loadCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_code'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 校验规则下拉数据获取函数
     */
    loadVerifyRuleDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_verify_rule'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 更新编辑指标模型
     */
    refreshEditPaIndexModel (reloadData = false) {
      this.loadPaIndexModelData().then(res => {
        if (!this.EditPaIndexModel.isInit) {
          // 初始化下拉数据
          this.EditPaIndexModel.code.impl.onVisibleChange(true).catch(e => {});
          this.EditPaIndexModel.verifyRule.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditPaIndexModel.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditPaIndexModel.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.EditPaIndexModel.type.impl.dropdownList, this.formData.PaIndexModel.type, 'id'),
            ...this.formData.PaIndexModel
          };
          this.onCancel(true, formData);
          return;
        }
        let detail = this.formData.PaIndexModel.detail;
        if (this.formData.PaIndexModel.gcode === 'pa_work') {
          if (this.formData.PaIndexModel.pa_work.indexWeightValue > 1) {
            this.$message.error('操作失败,权重不能大于1');
            return;
          }
          detail = this.formData.PaIndexModel.pa_work;
        }
        let params = {
          paIndexModelDto: {
            id: this.id,
            pid: this.formData.PaIndexModel.pid,
            type: this.formData.PaIndexModel.type,
            code: this.formData.PaIndexModel.code,
            gcode: this.formData.PaIndexModel.gcode,
            name: this.formData.PaIndexModel.name,
            detail: detail,
            remark: this.formData.PaIndexModel.remark,
            sort: this.formData.PaIndexModel.sort,
            enableCondition: this.formData.PaIndexModel.enableCondition,
            paramVariable: this.formData.PaIndexModel.paramVariable,
            indexValue: this.formData.PaIndexModel.indexValue,
            verifyRule: this.formData.PaIndexModel.verifyRule,
            evalFormula: this.formData.PaIndexModel.evalFormula,
            taskCode: this.formData.PaIndexModel.taskCode,
            inputVariable: this.formData.PaIndexModel.inputVariable
          }
        };

        PaIndexModelController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.refreshEditPaIndexModel();
          this.onSubmit(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEditPaIndexModel(true);
    },
    /**
     * 获取绩效指标模型详细信息
     */
    loadPaIndexModelData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaIndexModel.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaIndexModelController.view(this, params).then(res => {
            let paWork = this.formData.PaIndexModel.pa_work;
            this.formData.PaIndexModel = {...res.data, isDatasourceInit: true, pa_work: paWork};
            if (this.formData.PaIndexModel.typeDictMap && this.EditPaIndexModel.type.impl.dirty) {
              this.EditPaIndexModel.type.impl.dropdownList = [this.formData.PaIndexModel.typeDictMap];
            }
            let data = this.formData.PaIndexModel;
            if (data.gcode === 'pa_work') {
              data.pa_work = JSON.parse(data.detail);
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false,
          pa_work: {
            indexDefinition: '',
            indexTargetValue: '',
            indexWeightValue: 0,
            fullScoreLine: 0,
            deductionFactor: 0,
            indexScoreRule: ''
          }
        }
      }
    },
    formInit () {
      this.refreshEditPaIndexModel();
    }
  },
  computed: {
    // 初始化组件数据所需输入参数
    initPaIndexModelParamChange () {
      return {
        id: this.id
      }
    },
    // 监听输入参数变化，用于数据变化后重新获取数据，如果存在多个数据组件或者数据组件使用不同的输入参数的优化，请拆分这里的代码
    formInputParamChange () {
      return {
        id: this.id
      }
    }
  },
  watch: {
    // 初始化组件数据所需输入参数，如果有多个初始化数据源需要优化，请修改这里的代码，只重置和更新相应的数据源数据
    initPaIndexModelParamChange: {
      handler (newValue) {
        this.resetFormData();
        this.refreshEditPaIndexModel();
      },
      immediate: true
    },
    formInputParamChange: {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
